import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Replace this placeholder config with your actual Firebase project config keys.
// You can get this config from the Firebase Console:
// Project Settings -> General -> Your Apps -> Web App config
const firebaseConfig = {
  apiKey: "AIzaSyDrmbrnEHg2MX5qRzX_v5k4YgbIlUysUEw",
  authDomain: "house-of-karnnikaraa.firebaseapp.com",
  projectId: "house-of-karnnikaraa",
  storageBucket: "house-of-karnnikaraa.firebasestorage.app",
  messagingSenderId: "241039477616",
  appId: "1:241039477616:web:2f029d702cc68a1cce1db5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
